export default "__VITE_ASSET__DZIs$I9N__"